import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Divider, Flex, Row } from "antd";
import { FullLogoIcon } from "components/Icons";
import { Button } from "components/Common/Button";
import StyledEntry from "./styles";
import { BLOG_ENTRIES } from "utils/dummyBlogEntries";
import EntryCard from "pages/GetStarted/EntryCard";

const REQUEST_DEMO_LABEL = "Request a Demo";

const Header = () => {
	const navigate = useNavigate();

	const goToAnchor = () => {
		navigate("/");
		setTimeout(() => {
			const section = document.getElementById("request-demo");
			if (section) {
				section.scrollIntoView({ behavior: "smooth" });
			}
		}, 100);
	};

	return (
		<div className="header">
			<div style={{ zIndex: 3 }}>
				<Link to="/">
					<FullLogoIcon />
				</Link>
			</div>
			<div className="actions">
				<Button onClick={() => navigate("/gym-search")} className="transparent-btn">
					Find My Gym
				</Button>
				<Button onClick={goToAnchor} className="orange-btn">
					{REQUEST_DEMO_LABEL}
				</Button>
			</div>
		</div>
	);
};

const HeaderSection = ({ entry, children }) => {
	return (
		<div
			className="sb-blog__main-section"
			style={{
				backgroundImage: `url(${entry.thumbnail})`,
			}}
		>
			<Header />
			<div className="body">
				<p className="category">{entry.category}</p>
				<p className="title clash-display">{entry.title}</p>
				<p className="created-at">{entry.created_at}</p>
			</div>
			{children}
		</div>
	);
};

const EntryContainer = ({ entry }) => {
	const [expanded, setExpanded] = useState(false);
	return (
		<div className="sb-blog__entry-section">
			<div
				className="sb-blog__entry-section__thumbnail"
				style={{
					backgroundImage: `url(${entry.thumbnail})`,
				}}
			/>
			<p style={{ fontSize: 12 }}>
				Photo Credit: <span className="highlight">{entry.photo_credit}</span>
			</p>

			{!expanded ? (
				<div className="sb-blog__entry-section__content" dangerouslySetInnerHTML={{ __html: entry.content }} />
			) : (
				<div className="sb-blog__entry-section__expanded-content" dangerouslySetInnerHTML={{ __html: entry.content }} />
			)}
			<Flex className="more-section" justify="center">
				<Button
					onClick={() => setExpanded((prev) => !prev)}
					chevronDown={!expanded}
					chevronUp={expanded}
					className="transparent-btn read-more-btn"
				>
					{!expanded ? "Read More" : "Read Less"}
				</Button>
			</Flex>
		</div>
	);
};

const BlogItemsSection = ({ entry }) => {
	if (!entry) return null;
	return (
		<div className="sb-blog__items-section">
			<h1 className="title clash-display">Explore more</h1>
			<Row style={{ margin: "40px 0px" }} gutter={[16, 16]}>
				{BLOG_ENTRIES.map((entry) => (
					<Col key={entry.title} xs={24} sm={12} md={8} lg={6}>
						<EntryCard
							key={entry.title}
							thumbnail={entry.thumbnail}
							title={entry.title}
							category={entry.category}
							slug={entry.slug}
						/>
					</Col>
				))}
			</Row>
		</div>
	);
};

function Entry() {
	const { slug } = useParams();
	const entry = BLOG_ENTRIES.find((item) => item.slug === slug);

	return (
		<StyledEntry>
			<div className="sb-blog">
				<HeaderSection entry={entry}>
					<EntryContainer entry={entry} />
					<BlogItemsSection />
					<Footer />
				</HeaderSection>
			</div>
		</StyledEntry>
	);

	function Footer() {
		return (
			<div className="sb-blog__footer">
				<div className="">
					<Link to="/">
						<FullLogoIcon />
					</Link>
				</div>
				<Divider className="divider" size="small" />
				<div className="copyright">© Copyright 2012 - {new Date().getFullYear()}. All Rights Reserved.</div>
			</div>
		);
	}
}

export default Entry;

